// source: witbooking/loyalty/report/v1/report_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var witbooking_loyalty_customer_v1_customer_api_pb = require('../../../../witbooking/loyalty/customer/v1/customer_api_pb.js');
goog.object.extend(proto, witbooking_loyalty_customer_v1_customer_api_pb);
goog.exportSymbol('proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem', null, global);
goog.exportSymbol('proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest', null, global);
goog.exportSymbol('proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.displayName = 'proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.displayName = 'proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.displayName = 'proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    brandId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    filtersMap: (f = msg.getFiltersMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest;
  return proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBrandId(value);
      break;
    case 4:
      var value = msg.getFiltersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBrandId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFiltersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional int32 page_size = 1;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page_number = 2;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string brand_id = 3;
 * @return {string}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.getBrandId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.setBrandId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> filters = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.getFiltersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportRequest.prototype.clearFiltersMap = function() {
  this.getFiltersMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    totalElements: jspb.Message.getFieldWithDefault(msg, 2, 0),
    totalPages: jspb.Message.getFieldWithDefault(msg, 3, 0),
    first: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    last: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 6, 0),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse;
  return proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalElements(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPages(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFirst(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLast(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 7:
      var value = new proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem;
      reader.readMessage(value,proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getTotalElements();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTotalPages();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFirst();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getLast();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 page_size = 1;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total_elements = 2;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.getTotalElements = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.setTotalElements = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 total_pages = 3;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.getTotalPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.setTotalPages = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool first = 4;
 * @return {boolean}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.getFirst = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.setFirst = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool last = 5;
 * @return {boolean}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.getLast = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.setLast = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int32 page_number = 6;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * repeated CustomerTransactionReportItem items = 7;
 * @return {!Array<!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem>}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem, 7));
};


/**
 * @param {!Array<!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem>} value
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} returns this
*/
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem}
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse} returns this
 */
proto.witbooking.loyalty.report.v1.GetCustomerTransactionReportResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    customer: (f = msg.getCustomer()) && witbooking_loyalty_customer_v1_customer_api_pb.Customer.toObject(includeInstance, f),
    fromdate: (f = msg.getFromdate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    todate: (f = msg.getTodate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    totalReservationAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    totalReservationCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
    totalCancelledCount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    totalRoomNights: jspb.Message.getFieldWithDefault(msg, 14, 0),
    pastReservationAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    pastReservationCount: jspb.Message.getFieldWithDefault(msg, 16, 0),
    pastRoomNights: jspb.Message.getFieldWithDefault(msg, 17, 0),
    tierTicker: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem;
  return proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new witbooking_loyalty_customer_v1_customer_api_pb.Customer;
      reader.readMessage(value,witbooking_loyalty_customer_v1_customer_api_pb.Customer.deserializeBinaryFromReader);
      msg.setCustomer(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFromdate(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTodate(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalReservationAmount(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalReservationCount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCancelledCount(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalRoomNights(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPastReservationAmount(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPastReservationCount(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPastRoomNights(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setTierTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomer();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      witbooking_loyalty_customer_v1_customer_api_pb.Customer.serializeBinaryToWriter
    );
  }
  f = message.getFromdate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTodate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTotalReservationAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getTotalReservationCount();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getTotalCancelledCount();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getTotalRoomNights();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getPastReservationAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getPastReservationCount();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getPastRoomNights();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getTierTicker();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional witbooking.loyalty.customer.v1.Customer customer = 1;
 * @return {?proto.witbooking.loyalty.customer.v1.Customer}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getCustomer = function() {
  return /** @type{?proto.witbooking.loyalty.customer.v1.Customer} */ (
    jspb.Message.getWrapperField(this, witbooking_loyalty_customer_v1_customer_api_pb.Customer, 1));
};


/**
 * @param {?proto.witbooking.loyalty.customer.v1.Customer|undefined} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
*/
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setCustomer = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.clearCustomer = function() {
  return this.setCustomer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.hasCustomer = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Timestamp fromDate = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getFromdate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
*/
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setFromdate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.clearFromdate = function() {
  return this.setFromdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.hasFromdate = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp toDate = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getTodate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
*/
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setTodate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.clearTodate = function() {
  return this.setTodate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.hasTodate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional double total_reservation_amount = 11;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getTotalReservationAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setTotalReservationAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional int32 total_reservation_count = 12;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getTotalReservationCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setTotalReservationCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 total_cancelled_count = 13;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getTotalCancelledCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setTotalCancelledCount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 total_room_nights = 14;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getTotalRoomNights = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setTotalRoomNights = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional double past_reservation_amount = 15;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getPastReservationAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setPastReservationAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional int32 past_reservation_count = 16;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getPastReservationCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setPastReservationCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int32 past_room_nights = 17;
 * @return {number}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getPastRoomNights = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setPastRoomNights = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string tier_ticker = 18;
 * @return {string}
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.getTierTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem} returns this
 */
proto.witbooking.loyalty.report.v1.CustomerTransactionReportItem.prototype.setTierTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


goog.object.extend(exports, proto.witbooking.loyalty.report.v1);
